module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v("Air Freight Details")])], 1), _vm._v(" "), _c('div', [_c('h5', {
    staticClass: "text-muted pull-right mt-2 ml-3"
  }, [_c('small', [_vm._v(_vm._s(_vm.totalRows) + " Entries")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-10"
  }, [_c('b-form-group', [_c('b-input-group', [_c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "Type To Search"
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  }), _vm._v(" "), _c('b-input-group-append', [_c('b-button', {
    attrs: {
      "disabled": !_vm.filter
    },
    on: {
      "click": function($event) {
        _vm.filter = ''
      }
    }
  }, [_vm._v("Clear")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.dateStatusList,
      "option-value": "inv",
      "option-text": "int",
      "placeholder": "Select Date Filter"
    },
    on: {
      "input": function($event) {
        _vm.viewFFExportFCL()
      }
    },
    model: {
      value: (_vm.dateStatusFilter),
      callback: function($$v) {
        _vm.dateStatusFilter = $$v
      },
      expression: "dateStatusFilter"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive tableMain"
  }, [_c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "items": _vm.airFFData,
      "fields": _vm.fields,
      "current-page": _vm.currentPage,
      "per-page": _vm.perPage,
      "filter": _vm.filter,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "filtered": _vm.onFiltered
    },
    scopedSlots: _vm._u([{
      key: "airFcExportId",
      fn: function(row0) {
        return [_c('span', [_vm._v(_vm._s(row0.index + 1 + (_vm.currentPage - 1) * _vm.perPage))])]
      }
    }, {
      key: "clientNameAll",
      fn: function(row01) {
        return [_c('b', [_vm._v("\n              Client Name: " + _vm._s(row01.item.clientNameAll) + "\n              "), _c('br')]), _vm._v(" "), _c('b', [_vm._v("\n              Cargo Weight: " + _vm._s(row01.item.cargoGrossWeightAll) + "\n              "), _c('br')]), _vm._v(" "), (row01.item.overSeaClientId != '0') ? _c('b', [_vm._v("\n              Overseas Agent: " + _vm._s(row01.item.overseasAgent) + "\n              "), _c('br')]) : _vm._e()]
      }
    }, {
      key: "MAWBNumber",
      fn: function(row11) {
        return [_c('b', [_vm._v("\n              Flight Name: " + _vm._s(row11.item.airlineName) + "\n              "), _c('br')]), _vm._v(" "), _c('b', [_vm._v("\n              Flight No: " + _vm._s(row11.item.flightNumber) + "\n              "), _c('br')]), _vm._v(" "), _c('b', [_vm._v("\n              MAWB Number: " + _vm._s(row11.item.MAWBNumber) + "\n              "), _c('br')])]
      }
    }, {
      key: "airFFExportSeries",
      fn: function(row11) {
        return [_c('div', {
          staticClass: "showMoreData",
          on: {
            "click": function($event) {
              row11.item.is_locked == '1' &&
                (row11.item.finalBillingCompleted == 1 ||
                  row11.item.locked_counter > 0) &&
                _vm.$sessionsStorage.get('designation') != 'Admin' &&
                _vm.$sessionsStorage.get('nameUser') != 'Bhavneesh' ?
                '' :
                _vm.viewExportAirPage(row11.item.airFcExportId)
            }
          }
        }, [_c('b', [_vm._v("\n                " + _vm._s(row11.item.airFFExportSeries) + "\n                "), _c('br')]), _vm._v(" "), _c('span', [_vm._v("\n                Raised From : " + _vm._s(row11.item.EmpLoc) + "\n                "), _c('br')]), _vm._v(" "), _c('span', [_vm._v("\n                Date : " + _vm._s(_vm._f("moment")(row11.item.loginTime)) + "\n                "), _c('br')])]), _vm._v(" "), _c('Assignment-Summary', {
          attrs: {
            "title": 'Shipment Summary Tracking - ',
            "fk_all_module_id": row11.item.allModuleId,
            "jb_series": row11.item.airFFExportSeries
          }
        }), _vm._v(" "), _c('b-button', {
          staticClass: "mt-2",
          staticStyle: {
            "font-size": "0.675rem"
          },
          attrs: {
            "size": "sm",
            "variant": row11.item.is_locked == '1' &&
              (row11.item.finalBillingCompleted == 1 || row11.item.locked_counter > 0) ?
              'danger' :
              'success'
          },
          on: {
            "click": function($event) {
              row11.item.is_locked == '1' &&
                (row11.item.finalBillingCompleted == 1 || row11.item.locked_counter > 0) ?
                _vm.LockUnLock(row11.item, 'locked') :
                ''
            }
          }
        }, [(
          row11.item.is_locked == '1' &&
          (row11.item.finalBillingCompleted == 1 ||
            row11.item.locked_counter > 0)
        ) ? _c('b', [_c('i', {
          staticClass: "fa fa-lock mr-1 lg"
        }), _vm._v("LOCKED")]) : _c('b', [_c('i', {
          staticClass: "fa fa-unlock mr-1 lg"
        }), _vm._v("UN-LOCKED")])]), _c('br'), _vm._v(" "), (row11.item.finalBillingCompleted == '1') ? _c('span', [_c('b', {
          style: ('color:black')
        }, [_vm._v("Billing : ")]), _vm._v(" "), _c('b-badge', {
          attrs: {
            "variant": "success"
          }
        }, [_c('b', [_vm._v("Completed")])]), _c('br')], 1) : _vm._e(), _vm._v(" "), (row11.item.finalBillingCompleted == '0') ? _c('span', [_c('b', {
          style: ('color:black')
        }, [_vm._v("Billing : ")]), _vm._v(" "), _c('b-badge', {
          attrs: {
            "variant": "danger"
          }
        }, [_c('b', [_vm._v("Pending")])]), _c('br')], 1) : _vm._e()]
      }
    }, {
      key: "EmpLoc",
      fn: function(row55) {
        return [_c('b-button', {
          staticClass: "mt-2",
          staticStyle: {
            "font-size": "0.675rem"
          },
          attrs: {
            "size": "sm",
            "variant": "outline-info"
          },
          on: {
            "click": function($event) {
              _vm.showDocModal(row55.item)
            }
          }
        }, [_vm._v("Summary & Documents")]), _vm._v(" "), _c('Add-Message', {
          staticStyle: {
            "list-style-type": "none"
          },
          attrs: {
            "fk_all_module_id": row55.item.allModuleId
          }
        }), _vm._v(" "), _c('Overseas-CRDRNote', {
          attrs: {
            "title": row55.item.airFFExportSeries,
            "moduleType": 'FF ' + row55.item.MS_transportType + ' Module',
            "cr_all_module_id": row55.item.allModuleId,
            "cr_jb_series": row55.item.airFFExportSeries,
            "cr_ass_date": _vm._f("moment")(row55.item.loginTime),
            "transportType": row55.item.MS_transportType,
            "Jobtype": 'FF',
            "commonId": row55.item.airFcExportId,
            "shipmentType": row55.item.MS_shipmentType == '1' ||
              row55.item.MS_shipmentType == 'Sea_Shipment' ?
              'Sea' :
              'Air',
            "isOverseas": false,
            "ItemAr": null
          }
        }), _vm._v(" "), _c('MSDeleteRequest', {
          attrs: {
            "item": row55.item,
            "JobNo": row55.item.airFFExportSeries,
            "JobID": row55.item.allModuleId,
            "sessionsStorage": _vm.$sessionsStorage
          },
          on: {
            "refreshData": _vm.handleRefresh
          }
        }), _vm._v(" "), (row55.item.deleteRequestBy != '' && row55.item.deleteRequestBy != '0' && row55.item.deleteRequestBy != null) ? _c('b', [_vm._v("Requested By : " + _vm._s(row55.item.deleteRequestBy)), _c('br')]) : _vm._e(), _vm._v(" "), (row55.item.deleteArrovedBy != '' && row55.item.deleteArrovedBy != '0' && row55.item.deleteArrovedBy != null) ? _c('b', [_vm._v("Arroved By : " + _vm._s(row55.item.deleteArrovedBy)), _c('br')]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "12"
    }
  }, [_c('b-pagination', {
    attrs: {
      "limit": "5",
      "align": "center",
      "total-rows": _vm.totalRows,
      "per-page": _vm.perPage
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  }), _vm._v(" "), _c('b-modal', {
    ref: "doc-modal",
    staticClass: "modal-dialog-doc",
    attrs: {
      "size": "xl",
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "hide-footer": "",
      "title": 'Assignment Summary & Documents - ' + _vm.JOBSERIES
    }
  }, [(_vm.ALLMODULE) ? _c('div', [_c('doc-form', {
    attrs: {
      "allModuleIdProp": _vm.ALLMODULE,
      "JOBSERIES": _vm.JOBSERIES
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "variant": "outline-danger",
      "block": ""
    },
    on: {
      "click": _vm.hideDocModal
    }
  }, [_vm._v("Close\n    ")])], 1), _vm._v(" "), _c('b-modal', {
    ref: "modal-lock-conf",
    attrs: {
      "id": "modal-lock-conf",
      "title": "Reason for Open Locked Assignment",
      "centered": "",
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "hide-footer": ""
    }
  }, [_c('h3', [_vm._v("Confirmation")]), _vm._v(" "), _c('form', {
    ref: "form"
  }, [_c('b-form-group', {
    attrs: {
      "label": "Remark",
      "label-for": "name-input",
      "invalid-feedback": "Name is required"
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "rows": "5",
      "id": "name-input",
      "required": ""
    },
    model: {
      value: (_vm.lockReason),
      callback: function($$v) {
        _vm.lockReason = $$v
      },
      expression: "lockReason"
    }
  })], 1)], 1), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "danger"
    },
    on: {
      "click": _vm.closeLockUnLockConfirm
    }
  }, [_vm._v(" Cancel")]), _vm._v(" "), (_vm.lockReason) ? _c('b-button', {
    staticClass: "pull-right",
    attrs: {
      "disabled": _vm.lock_button ? true : false,
      "variant": "success"
    },
    on: {
      "click": _vm.ConfLock
    }
  }, [_vm._v("Send")]) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-41e90b89","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/airFreight/viewAirFF.vue
// module id = 2560
// module chunks = 0